<script setup lang="ts">
const props = defineProps<{
  id: string;
  label?: string;
}>();

const defaultLabel = 'Expected rental income';
</script>
<template>
  <BxField v-slot="{ field }" name="rentalIncome">
    <BxPeriodicAmount
      :id="id + '-expected-rental-income'"
      v-bind="field"
      :label="props.label ?? defaultLabel"
      label-type="floating"
      leading-symbol="$"
      class="form-control"
    />
  </BxField>
</template>
